export interface PropertyValue {
  key: any;
  value: any;
}
